import React, { Component } from "react";
import { useLocation, NavLink } from "react-router-dom";

import { Nav } from "react-bootstrap";

import logo from "assets/img/reactlogo.png";

function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  return (
    <div className="sidebar" data-image={image} data-color={color}>
      <div
        className="sidebar-background"
        style={{
          backgroundImage: "url(" + image + ")",
        }}
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a
            className="simple-text logo-mini mx-1"
          >
            <div className="logo-img">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                style={{
                  width: '32px',
                  height: '32px',
                  maxWidth: '32px',
                  maxHeight: '32px'
                }}
              >
                <circle cx="12" cy="12" r="10" fill="#0B1F3A"/>
                <text x="12" y="16" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">F</text>
              </svg>
            </div>
          </a>
          <a className="simple-text" style={{color: 'white', fontWeight: '600', fontSize: '16px', textDecoration: 'none'}}>
            Finova
          </a>
        </div>
        <Nav>
          {routes.map((prop, key) => {
            if (!prop.redirect)
              return (
                <li
                  className={
                    prop.upgrade
                      ? "active active-pro"
                      : activeRoute(prop.layout + prop.path)
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                    style={{display: 'flex', alignItems: 'center', gap: '12px', color: 'rgba(255, 255, 255, 0.9)'}}
                  >
                    <i className={prop.icon} style={{fontSize: '16px', color: 'rgba(255, 255, 255, 0.8)', width: '20px', textAlign: 'center'}} />
                    <span style={{color: 'rgba(255, 255, 255, 0.9)', fontWeight: '500', fontSize: '14px'}}>{prop.name}</span>
                  </NavLink>
                </li>
              );
            return null;
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
